import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildUpdateMutations } from '@/store/extensions/update';

export default {
  ...buildFetchMutations(['fetchApps', 'fetchSingleApp']),
  ...buildUpdateMutations(['subscribe', 'cancelSubscription']),
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js